import ListItemIcon from '@mui/material/ListItemIcon';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { getLocale } from '@karpeleslab/klbfw';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchLang } from '../../../store/actions/system/LangAction';
import Flag from '../data/flag/Flag';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

const LangBox = styled(Grid)(({ theme }) => ({
  marginRight: theme.spacing(2),
  marginTop: '3px'
}));

const CenteredGrid = styled(Grid)({
  marginRight: 'auto', 
  marginLeft: 'auto',
  cursor: 'pointer'
});

const CenteredTextGrid = styled(Grid)({
  textAlign: 'center',
  cursor: 'pointer'
});

const UnstyledLink = styled('a')({
  textDecoration: 'none'
});

const LanguageSwitcher = () => {
  const [menu, setMenu] = useState(null);
  const location = useLocation();
  const dispatch = useDispatch();
  
  // Use selector hooks instead of connect
  const lang = useSelector(state => state.lang);

  useEffect(() => {
    dispatch(fetchLang());
  }, [dispatch]);

  const userMenuClick = event => {
    setMenu(event.currentTarget);
  };

  const userMenuClose = () => {
    setMenu(null);
  };

  return (
    <Grid container spacing={2}>
      <CenteredGrid item onClick={userMenuClick} justifyContent="center" alignItems="center">
        <Flag
          ratio="4x3"
          size="small"
          code={getLocale().split('-')[1].toLowerCase()}
          alt={getLocale()}
        />
      </CenteredGrid>
      <CenteredTextGrid item xs={12} onClick={userMenuClick}>
        {lang.data.map(lng => (
          getLocale() === lng.Language__ &&
          <Typography variant="body2" color="textSecondary" component="p" key={lng.Language__}>
            {lng.Local_Name}
          </Typography>
        ))}
      </CenteredTextGrid>
      <Popover
        open={Boolean(menu)}
        anchorEl={menu}
        onClose={userMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        classes={{
          paper: 'py-8'
        }}
      >
        <Grid item xs={12}>
          {lang.data.map(lng => (
            <UnstyledLink 
              href={`/l/${lng.Language__}${location.pathname}`} 
              key={lng.Language__}
            >
              <MenuItem onClick={userMenuClose}>
                <ListItemIcon>
                  <LangBox>
                    <Flag
                      ratio="4x3"
                      size="small"
                      code={lng.Language__.split('-')[1].toLowerCase()}
                      alt={lng.Local_Name}
                    />
                  </LangBox>
                  <Grid>
                    {lng.Local_Name}
                  </Grid>
                </ListItemIcon>
              </MenuItem>
            </UnstyledLink>
          ))}
        </Grid>
      </Popover>
    </Grid>
  );
};

export default LanguageSwitcher;